import { TypedUseLazyQueryStateResult } from "@reduxjs/toolkit/query/react";
import { useCallback } from "react";

import { dataSourceIdMap } from "features/data-source/data-source-id-map";
import { DataSourceName } from "features/data-source/data-source.types";
import { useHasUserArea } from "hooks/useHasUserArea";
import {
    DataSourceParameter,
    GetDataSourceOptionsV1,
    useLazyGetDataSourceQuery as useLazyGetDataSourceQueryJSBE,
} from "store/services/data-source.service";
import {
    GetDataSourceDeprecatedOptions,
    useLazyGetDataSourceQuery as useLazyGetDataSourceQueryCSBE,
} from "store/services/deprecated/data-source.service";

export const useLazyDataSourceOldApproach = <T = any>(dataSource: DataSourceName) => {
    // Checks which data source query endpoint (C# vs JS) to call based on area
    const hasJSBEDataSourcesEnabled = useHasUserArea(["Refactor_JSBEDataSources"]);

    const [_triggerJSBE, resultJSBE] = useLazyGetDataSourceQueryJSBE();
    const [_triggerCSBE, resultCSBE] = useLazyGetDataSourceQueryCSBE();

    const trigger = useCallback(
        (parameters?: DataSourceParameter[], preferCacheValue?: boolean) => {
            if (hasJSBEDataSourcesEnabled) {
                // Always use v1 endpoint for JSBE
                return _triggerJSBE(
                    {
                        apiVersion: "v1",
                        id: dataSourceIdMap[dataSource],
                        parameters,
                    } as GetDataSourceOptionsV1,
                    preferCacheValue
                );
            } else {
                // Use CSBE endpoint
                return _triggerCSBE(
                    {
                        id: dataSourceIdMap[dataSource],
                        parameters,
                    } as GetDataSourceDeprecatedOptions,
                    preferCacheValue
                );
            }
        },
        [hasJSBEDataSourcesEnabled, _triggerJSBE, _triggerCSBE, dataSource]
    );

    const result = hasJSBEDataSourcesEnabled ? resultJSBE : resultCSBE;

    return [trigger, result] as [typeof trigger, TypedUseLazyQueryStateResult<T, any, any>];
};
